import type { ReactNode } from 'react'
import { useParams } from 'react-router-dom'
import { useChatWindow } from './hooks/useChatWindow'
import { useMindMapContext } from '../../../../context/mindmap'
import type { MindMapNode, MindMapEdge } from '@bandos/shared'
import { ChatWindowContext } from './ChatWindowContextDef'

interface ChatWindowProviderProps {
  children: ReactNode
  onAddNodes?: (nodes: MindMapNode[], edges: MindMapEdge[]) => void
}

/**
 * Provider that owns the chat window state.
 * Must be used within MindMapProvider (needs access to nodes/edges).
 * Children can use useChatWindowContext() to access chat functionality.
 */
export function ChatWindowProvider({ children, onAddNodes }: ChatWindowProviderProps) {
  const { id: mindmapId } = useParams<{ id: string }>()
  const { nodes, edges } = useMindMapContext()

  const chatWindow = useChatWindow({
    mindmapId,
    nodes,
    edges,
    onAddNodes,
  })

  return <ChatWindowContext.Provider value={chatWindow}>{children}</ChatWindowContext.Provider>
}
